import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { SchedulePostModalContext } from ".";
import { Divider } from "../../../commonStyles";
import { FlexRowCenter } from "../Styles";

const SchedulePostHeader = () => {
  const { typography } = useTheme();
  const { setSchedulePostOpen, title } = useContext(SchedulePostModalContext);
  return (
    <>
      <Container>
        <FlexRowCenter>
          <Components.IconButton
            disabled={false}
            iconType="ArrowLeft"
            kind="Tertiary"
            onClick={() => setSchedulePostOpen(false)}
            size="Medium"
          />
          <Components.Text
            text={title}
            style={{ tokenStyle: typography.Heading.S }}
            fontWeight="font-weight-semibold"
          />
        </FlexRowCenter>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Tertiary"
          onClick={() => setSchedulePostOpen(false)}
          size="Medium"
        />
      </Container>
      <Divider />
    </>
  );
};

export default SchedulePostHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
